<template>
    <div class="settings-clients-create">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Criar Cliente</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <!-- Formulario de cadastro/edição de cliente -->
        <mu-form-client type="create"></mu-form-client>

    </div>
</template>

<script>
    export default {
        name: 'app-settings-clients-create',
        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Configurações',
                        route: 'app.settings',
                        disabled: false
                    },
                    {
                        text: 'Clientes',
                        route: 'app.settings.clients',
                        disabled: false
                    },
                    {
                        text: 'Criar Cliente',
                        disabled: true
                    }
                ]
            }
        }
    }
</script>
